
export class NetworkProperties {
    public versionNumber: string;
    public deployTime: number;
    public isApproval: boolean;
}
